import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n-lite';
import { PropTypes } from 'prop-types';
import _ from 'lodash';
import CommentBox from '../CommentBox';
import UserResponse from './UserResponse';
import UploadFileContainer from './UploadFileContainer';
import FileEvaluationBox from './FileEvaluationBox';
import * as taskService from '../../../services/domain/taskService';
import { getAsset } from '../../../services/assets/assetsService';

class FirstEvaluationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      task: {},
      user: {},
      customer: {}
    };
  }
  componentDidMount() {
    this.getResponseFile();
  }
  async getResponseFile() {
    const { task, user, customer } = this.props;
    if (task.studentAttempts[user._id].responses.length > 0 && task.studentAttempts[user._id].responses[0].data.files) {
      const response = task.studentAttempts[user._id].responses[0];
      const files = response.data.files;
      if (files && files.length) {
        const getAssetPromises = files.map(res => getAsset(res.split('/').pop(), customer.id));

        Promise.allSettled(getAssetPromises).then(res => {
          const okResponses = res.filter(r => r.status !== 'rejected');
          this.setState({
            responseFile: okResponses.map(r => r.value.data)
          });
        });
      }
    }
  }
  render() {
    const { task, user } = this.props;

    let result;
    let comment;
    let evaluatedBy;
    let firstCommentResponse;
    let grade;
    if (
      task.studentAttempts[user._id] &&
      task.studentAttempts[user._id].responses &&
      task.studentAttempts[user._id].responses.length &&
      task.studentAttempts[user._id].responses[0].evaluation
    ) {
      result = task.studentAttempts[user._id].responses[0].evaluation.grade;
      evaluatedBy = task.studentAttempts[user._id].responses[0].evaluation.updatedBy;
      grade = taskService.getTaskFirstGrade(task, user._id);
    }

    if (
      task.studentAttempts &&
      task.studentAttempts[user._id] &&
      task.studentAttempts[user._id].responses &&
      task.studentAttempts[user._id].responses[0] &&
      task.studentAttempts[user._id].responses[0].evaluation
    ) {
      firstCommentResponse = task.studentAttempts[user._id].responses[0].data.commentMessageText;
      comment = task.studentAttempts[user._id].responses[0].evaluation.comment;
    }

    let showComment = !_.isNil(result);

    // Comprobar si tiene evaluacion
    const showEvaluationFile = Boolean(
      task.studentAttempts[user._id] &&
        task.studentAttempts[user._id].evaluation &&
        task.studentAttempts[user._id].responses[0].evaluation &&
        task.studentAttempts[user._id].responses[0].evaluation.attachments &&
        task.studentAttempts[user._id].responses[0].evaluation.attachments.length
    );
    const showResponseFile = Boolean(
      task.studentAttempts[user._id] &&
        task.studentAttempts[user._id].responses &&
        task.studentAttempts[user._id].responses[0].data.files
    );

    return showComment ? (
      <>
        <CommentBox
          showCommentBox={grade !== null}
          comment={comment}
          userId={evaluatedBy ? evaluatedBy : task.teacherImage}
          grade={grade}
          title={I18n.t('panels.assignment.globalAssessment')}
          isFirstTry={true}
        />

        {showEvaluationFile && <FileEvaluationBox task={task} student={user} isFirstTry={true} />}
        {task.allowUserCommentResponse && <UserResponse disabled={true} value={firstCommentResponse} />}
        {showResponseFile && (
          <UploadFileContainer
            disableClick={true}
            defaultFile={this.state.responseFile}
            showLoader={false}
            canChange={false}
            isEvaluated={true}
            isTaskFile={true}
            isInstructor={false}
          />
        )}
      </>
    ) : null;
  }
}

FirstEvaluationContainer.propTypes = {
  task: PropTypes.any,
  user: PropTypes.any,
  customer: PropTypes.object
};
export default FirstEvaluationContainer;
